import SimpleLightbox from 'simplelightbox'

export class ProductGallery {
  constructor() {
    document.querySelectorAll('.s-product-gallery__grid').forEach((grid) => {
      const links = grid.querySelectorAll('a')

      if (!links.length) {
        return
      }

      new SimpleLightbox(links, {
        captions: false,
        history: false,
      })
    })
  }
}
